/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Abbreviation } from '../models/Abbreviation';
import type { AdditionalData } from '../models/AdditionalData';
import type { CategoryId } from '../models/CategoryId';
import type { DocumentUploadBody } from '../models/DocumentUploadBody';
import type { Employees } from '../models/Employees';
import type { GeoPosition } from '../models/GeoPosition';
import type { Manufacturers } from '../models/Manufacturers';
import type { ToolDetail } from '../models/ToolDetail';
import type { ToolDownloadUrlResponse } from '../models/ToolDownloadUrlResponse';
import type { ToolFilterOptions } from '../models/ToolFilterOptions';
import type { ToolForm } from '../models/ToolForm';
import type { ToolHistoryResponse } from '../models/ToolHistoryResponse';
import type { ToolId } from '../models/ToolId';
import type { ToolInventory } from '../models/ToolInventory';
import type { ToolInventoryCreateBody } from '../models/ToolInventoryCreateBody';
import type { ToolInventoryUpdateBody } from '../models/ToolInventoryUpdateBody';
import type { Tools } from '../models/Tools';
import type { Validation } from '../models/Validation';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ToolAdministrationService {
    /**
     * get next abbreviation
     * @param requestBody
     * @returns Abbreviation next abbreviation
     * @throws ApiError
     */
    public static nextAbbreviation(
        requestBody?: CategoryId,
    ): CancelablePromise<Abbreviation> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/abbreviations/next',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * validate abbreviation
     * @param requestBody
     * @returns Validation validate abbreviation
     * @throws ApiError
     */
    public static validateAbbreviation(
        requestBody?: Abbreviation,
    ): CancelablePromise<Validation> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/abbreviations/validate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * returns additional data
     * @returns AdditionalData successful
     * @throws ApiError
     */
    public static getAdditionalData(): CancelablePromise<AdditionalData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/additional_data',
        });
    }
    /**
     * list tool history
     * @param id id
     * @returns ToolHistoryResponse successful
     * @throws ApiError
     */
    public static getToolHistory(
        id: string,
    ): CancelablePromise<ToolHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/tools/{id}/history',
            path: {
                'id': id,
            },
        });
    }
    /**
     * list all managers for tools
     * @returns Employees successful
     * @throws ApiError
     */
    public static getManagers(): CancelablePromise<Employees> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/managers',
        });
    }
    /**
     * list all tool manufacturers once in order
     * @returns Manufacturers successful
     * @throws ApiError
     */
    public static getManufacturers(): CancelablePromise<Manufacturers> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/manufacturers',
        });
    }
    /**
     * list all employees responsible for tools
     * @returns Employees successful
     * @throws ApiError
     */
    public static getResponsibleEmployees(): CancelablePromise<Employees> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/responsible_employees',
        });
    }
    /**
     * get next tool_id
     * @param requestBody
     * @returns ToolId next tool_id
     * @throws ApiError
     */
    public static nextToolId(
        requestBody?: CategoryId,
    ): CancelablePromise<ToolId> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/tool_ids/next',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * validate tool_id
     * @param requestBody
     * @returns Validation validate tool_id
     * @throws ApiError
     */
    public static validateToolId(
        requestBody?: ToolId,
    ): CancelablePromise<Validation> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/tool_ids/validate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * upload tool document
     * @param id id
     * @param formData
     * @returns void
     * @throws ApiError
     */
    public static uploadDocument(
        id: string,
        formData: DocumentUploadBody,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/tools/{id}/documents',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `invalid file type`,
                409: `file already exists`,
            },
        });
    }
    /**
     * document download url
     * @param toolId tool_id
     * @param id id
     * @returns ToolDownloadUrlResponse return download link
     * @throws ApiError
     */
    public static downloadUrl(
        toolId: string,
        id: string,
    ): CancelablePromise<ToolDownloadUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/tools/{tool_id}/documents/{id}',
            path: {
                'tool_id': toolId,
                'id': id,
            },
        });
    }
    /**
     * delete document
     * @param toolId tool_id
     * @param id id
     * @returns void
     * @throws ApiError
     */
    public static deleteDocument(
        toolId: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/resources/tool_administration/tools/{tool_id}/documents/{id}',
            path: {
                'tool_id': toolId,
                'id': id,
            },
        });
    }
    /**
     * create inventory for tool
     * @param toolId tool_id
     * @param formData
     * @returns void
     * @throws ApiError
     */
    public static createInventory(
        toolId: string,
        formData: ToolInventoryCreateBody,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/inventories/{tool_id}',
            path: {
                'tool_id': toolId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `photo missing`,
                422: `outside inventory period`,
            },
        });
    }
    /**
     * show inventory
     * @param id tool inventory id
     * @returns ToolInventory inventory found
     * @throws ApiError
     */
    public static getInventoryDetail(
        id: string,
    ): CancelablePromise<ToolInventory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/inventories/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * update inventory
     * @param id tool inventory id
     * @param formData
     * @param photoIdsToDeleteArray
     * @returns void
     * @throws ApiError
     */
    public static updateInventory(
        id: string,
        formData: ToolInventoryUpdateBody,
        photoIdsToDeleteArray?: Array<string>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/resources/tool_administration/inventories/{id}',
            path: {
                'id': id,
            },
            query: {
                'photo_ids_to_delete[]': photoIdsToDeleteArray,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * delete inventory
     * @param id tool inventory id
     * @returns void
     * @throws ApiError
     */
    public static deleteInventory(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/resources/tool_administration/inventories/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * move inventory to other tool
     * @param id tool inventory id
     * @param toToolId to tool id
     * @returns void
     * @throws ApiError
     */
    public static moveInventory(
        id: string,
        toToolId?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/inventories/{id}/move',
            path: {
                'id': id,
            },
            query: {
                'to_tool_id': toToolId,
            },
        });
    }
    /**
     * get thumbnail for inventory photo
     * @param photoId tool inventory photo id
     * @returns binary thumbnail retrieved
     * @throws ApiError
     */
    public static getInventoryPhotoThumbnail(
        photoId: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/inventories/photos/{photo_id}/thumbnail',
            path: {
                'photo_id': photoId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * with ms graph error
     * @param photoId tool_id
     * @returns ToolDownloadUrlResponse return download link
     * @throws ApiError
     */
    public static downloadPhotoUrl(
        photoId: string,
    ): CancelablePromise<ToolDownloadUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/inventories/photos/{photo_id}/image_url',
            path: {
                'photo_id': photoId,
            },
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * list tools
     * @param page
     * @param active
     * @param billable
     * @param categoryId
     * @param limit
     * @param searchText
     * @param serialNumber
     * @param withoutResponsibleEmployee
     * @param responsibilityStatesArray
     * @param responsibleEmployeeIdsArray
     * @param managerIdsArray
     * @param tenantIdsArray
     * @param abbreviationsArray
     * @returns Tools successful
     * @throws ApiError
     */
    public static getTools(
        page?: number,
        active?: boolean,
        billable?: boolean,
        categoryId?: string,
        limit?: number,
        searchText?: string,
        serialNumber?: string,
        withoutResponsibleEmployee?: boolean,
        responsibilityStatesArray?: Array<'available' | 'assigned' | 'taken'>,
        responsibleEmployeeIdsArray?: Array<string>,
        managerIdsArray?: Array<string>,
        tenantIdsArray?: Array<string>,
        abbreviationsArray?: Array<string>,
    ): CancelablePromise<Tools> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/tools',
            query: {
                'page': page,
                'active': active,
                'billable': billable,
                'category_id': categoryId,
                'limit': limit,
                'search_text': searchText,
                'serial_number': serialNumber,
                'without_responsible_employee': withoutResponsibleEmployee,
                'responsibility_states[]': responsibilityStatesArray,
                'responsible_employee_ids[]': responsibleEmployeeIdsArray,
                'manager_ids[]': managerIdsArray,
                'tenant_ids[]': tenantIdsArray,
                'abbreviations[]': abbreviationsArray,
            },
        });
    }
    /**
     * create new tool
     * @param requestBody
     * @returns ToolDetail tool created
     * @throws ApiError
     */
    public static createTool(
        requestBody?: ToolForm,
    ): CancelablePromise<ToolDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/tools',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `invalid request`,
            },
        });
    }
    /**
     * filter options
     * @param active
     * @param billable
     * @param categoryId
     * @param searchText
     * @param serialNumber
     * @param withoutResponsibleEmployee
     * @param responsibilityStatesArray
     * @param responsibleEmployeeIdsArray
     * @param managerIdsArray
     * @param tenantIdsArray
     * @param abbreviationsArray
     * @returns ToolFilterOptions successful
     * @throws ApiError
     */
    public static getFilterOptions(
        active?: boolean,
        billable?: boolean,
        categoryId?: string,
        searchText?: string,
        serialNumber?: string,
        withoutResponsibleEmployee?: boolean,
        responsibilityStatesArray?: Array<'available' | 'assigned' | 'taken'>,
        responsibleEmployeeIdsArray?: Array<string>,
        managerIdsArray?: Array<string>,
        tenantIdsArray?: Array<string>,
        abbreviationsArray?: Array<string>,
    ): CancelablePromise<ToolFilterOptions> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/tools/filter_options',
            query: {
                'active': active,
                'billable': billable,
                'category_id': categoryId,
                'search_text': searchText,
                'serial_number': serialNumber,
                'without_responsible_employee': withoutResponsibleEmployee,
                'responsibility_states[]': responsibilityStatesArray,
                'responsible_employee_ids[]': responsibleEmployeeIdsArray,
                'manager_ids[]': managerIdsArray,
                'tenant_ids[]': tenantIdsArray,
                'abbreviations[]': abbreviationsArray,
            },
        });
    }
    /**
     * tool details
     * @param id id
     * @returns ToolDetail successful
     * @throws ApiError
     */
    public static getToolDetail(
        id: string,
    ): CancelablePromise<ToolDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/tools/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * update tool
     * @param id id
     * @param xOriginalRequestAt
     * @param requestBody
     * @returns ToolDetail tool updated
     * @throws ApiError
     */
    public static updateTool(
        id: string,
        xOriginalRequestAt?: string,
        requestBody?: ToolForm,
    ): CancelablePromise<ToolDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/resources/tool_administration/tools/{id}',
            path: {
                'id': id,
            },
            headers: {
                'X-Original-Request-At': xOriginalRequestAt,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `invalid request`,
            },
        });
    }
    /**
     * assign tool
     * @param id id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static assignTool(
        id: string,
        requestBody?: {
            responsible_employee_id: string;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/resources/tool_administration/tools/{id}/assign',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `when current employee does not have the can assign tool ability`,
            },
        });
    }
    /**
     * reject tool
     * @param id id
     * @param xOriginalRequestAt
     * @returns void
     * @throws ApiError
     */
    public static rejectTool(
        id: string,
        xOriginalRequestAt?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/resources/tool_administration/tools/{id}/reject',
            path: {
                'id': id,
            },
            headers: {
                'X-Original-Request-At': xOriginalRequestAt,
            },
        });
    }
    /**
     * make tool available
     * @param id id
     * @returns void
     * @throws ApiError
     */
    public static makeToolAvailable(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/resources/tool_administration/tools/{id}/make_available',
            path: {
                'id': id,
            },
            errors: {
                403: `when current employee does not have the can assign tool ability`,
            },
        });
    }
    /**
     * take tool
     * @param id id
     * @param xOriginalRequestAt
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static takeTool(
        id: string,
        xOriginalRequestAt?: string,
        requestBody?: {
            position: GeoPosition | null;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/resources/tool_administration/tools/{id}/take',
            path: {
                'id': id,
            },
            headers: {
                'X-Original-Request-At': xOriginalRequestAt,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * return tool
     * @param id id
     * @param xOriginalRequestAt
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static returnTool(
        id: string,
        xOriginalRequestAt?: string,
        requestBody?: {
            position: GeoPosition | null;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/resources/tool_administration/tools/{id}/return',
            path: {
                'id': id,
            },
            headers: {
                'X-Original-Request-At': xOriginalRequestAt,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * export all tools as csv
     * @param active
     * @param billable
     * @param categoryId
     * @param searchText
     * @param serialNumber
     * @param withoutResponsibleEmployee
     * @param responsibilityStatesArray
     * @param responsibleEmployeeIdsArray
     * @param managerIdsArray
     * @param tenantIdsArray
     * @param abbreviationsArray
     * @returns binary successfully sends export data
     * @throws ApiError
     */
    public static exportTools(
        active?: boolean,
        billable?: boolean,
        categoryId?: string,
        searchText?: string,
        serialNumber?: string,
        withoutResponsibleEmployee?: boolean,
        responsibilityStatesArray?: Array<'available' | 'assigned' | 'taken'>,
        responsibleEmployeeIdsArray?: Array<string>,
        managerIdsArray?: Array<string>,
        tenantIdsArray?: Array<string>,
        abbreviationsArray?: Array<string>,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/tools/export',
            query: {
                'active': active,
                'billable': billable,
                'category_id': categoryId,
                'search_text': searchText,
                'serial_number': serialNumber,
                'without_responsible_employee': withoutResponsibleEmployee,
                'responsibility_states[]': responsibilityStatesArray,
                'responsible_employee_ids[]': responsibleEmployeeIdsArray,
                'manager_ids[]': managerIdsArray,
                'tenant_ids[]': tenantIdsArray,
                'abbreviations[]': abbreviationsArray,
            },
        });
    }
}
